import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faTable } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import '../AdminCommon.css';
import './NewMesa.css';

export default function NewMesa({ onMesaCreated }) {
    const [mesa, setMesa] = useState('');
    const [cargando, setCargando] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setMesa('');
        setModalOpen(!modalOpen);
    };

    const crear = async (e) => {
        if (e) e.preventDefault();

        if (!mesa.trim()) {
            toast.warn('Por favor, ingresa el nombre o número de la mesa.');
            return;
        }

        const formData = new FormData();
        formData.append('mesa', mesa.trim());
        formData.append('estado', 'libre');

        setCargando(true);
        try {
            const response = await fetch(`${baseURL}/mesaPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                toggleModal();
                if (typeof onMesaCreated === 'function') {
                    onMesaCreated();
                } else {
                    window.location.reload();
                }
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al registrar mesa:', error);
            toast.error('Error de conexión. Inténtalo de nuevo.');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div>
            <button onClick={toggleModal} className="adminBtnPrimary" title="Registrar una nueva mesa para el restaurante">
                <FontAwesomeIcon icon={faPlus} /> Agregar mesa
            </button>

            {modalOpen && (
                <div className="adminModalOverlay" onClick={toggleModal}>
                    <div className="adminModalContent modalSmallSimple" onClick={(e) => e.stopPropagation()}>
                        <div className="adminModalHeader">
                            <h3><FontAwesomeIcon icon={faTable} /> Agregar Nueva Mesa</h3>
                            <button type="button" className="adminModalClose" onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={crear}>
                            <div className="adminModalBody">
                                <div className="adminFormField">
                                    <label>Identificador de la Mesa (Obligatorio):</label>
                                    <input
                                        type="text"
                                        placeholder="Ej: Mesa 1, Mesa Terraza 4, Barra 2..."
                                        value={mesa}
                                        onChange={(e) => setMesa(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                    <small style={{ color: '#64748b', fontSize: '12px' }}>
                                        El sistema generará automáticamente un código QR único para que los clientes hagan pedidos desde esta mesa.
                                    </small>
                                </div>
                            </div>

                            <div className="adminModalFooter">
                                <button type="button" className="adminBtnSecondary" onClick={toggleModal} disabled={cargando}>
                                    Cancelar
                                </button>
                                <button type="submit" className="adminBtnPrimary" disabled={cargando}>
                                    {cargando ? 'Guardando...' : 'Guardar Mesa'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
